
import React from "react";
import { RowStopTime } from "../molecules/RowStopTime";
import { QueryTimeTables } from "../ReactQuery/QueryTimeTables";

export const TimeTable = (props) => {
  const { nowTime } = props;
  const TimeTableAt1 = QueryTimeTables(["1", nowTime]);
  const TimeTableAt2 = QueryTimeTables(["2", nowTime]);
  const TimeTableAt3 = QueryTimeTables(["3", nowTime]);
  const TimeTableAt4 = QueryTimeTables(["4", nowTime]);
  const TimeTableAt5 = QueryTimeTables(["5", nowTime]);
  const TimeTableAt6 = QueryTimeTables(["6", nowTime]);
  const TimeTableAt7 = QueryTimeTables(["7", nowTime]);
  const TimeTableAt8 = QueryTimeTables(["8", nowTime]);
  const TimeTableAt9 = QueryTimeTables(["9", nowTime]);

  return (
    <>
      <RowStopTime
        platform_code="1"
        color="#0068b7"
        backColor="#f2f2f2"
        firstStoptime={TimeTableAt1[0]}
        secondStoptime={TimeTableAt1[1]}
      />
      <RowStopTime
        platform_code="2"
        color="#fadf00" 
        backColor="#e3e3e3"
        firstStoptime={TimeTableAt2[0]}
        secondStoptime={TimeTableAt2[1]}
      />
      <RowStopTime
        platform_code="3"
        color="#ea609e"
        backColor="#f2f2f2"
        firstStoptime={TimeTableAt3[0]}
        secondStoptime={TimeTableAt3[1]}
      />
      <RowStopTime
        platform_code="4"
        color="#b8d200"
        backColor="#e3e3e3"
        firstStoptime={TimeTableAt4[0]}
        secondStoptime={TimeTableAt4[1]}
      />
      <RowStopTime
        platform_code="5"
        color="#eb9500"
        backColor="#f2f2f2"
        firstStoptime={TimeTableAt5[0]}
        secondStoptime={TimeTableAt5[1]}
      />
      <RowStopTime
        platform_code="6"
        color="#57c1ed"
        backColor="#e3e3e3"
        firstStoptime={TimeTableAt6[0]}
        secondStoptime={TimeTableAt6[1]}
      />
      <RowStopTime
        platform_code="7"
        color="#930b80"
        backColor="#f2f2f2"
        firstStoptime={TimeTableAt7[0]}
        secondStoptime={TimeTableAt7[1]}
      />
      <RowStopTime
        platform_code="8"
        color="#009c74"
        backColor="#e3e3e3"
        firstStoptime={TimeTableAt8[0]}
        secondStoptime={TimeTableAt8[1]}
      />
      <RowStopTime
        platform_code="9"
        color="#da3915"
        backColor="#f2f2f2"
        firstStoptime={TimeTableAt9[0]}
        secondStoptime={TimeTableAt9[1]}
      />
    </>
  );
};


const stoptime1 = {
  agency_id: "80801005354",
  route_short_name: "沼13",
  service_id: "平日",
  departure_time: "07:00",
  stop_headsign: "東平沼（江原公園・ららぽーと沼津・沼津市立病院 経由）",
  stop_headsign_en: "Higashi Hiranuma [Ebara Koen , LaLaport Numazu , Numazu Shiritu Byoin]  ",
  platform_code: "1"
};

const stoptime2 = {
  agency_id: "80801005354",
  route_short_name: "沼13",
  service_id: "平日",
  departure_time: "07:30",
  stop_headsign: "沼津港",
  stop_headsign_en: "Numadu-port",
  platform_code: "1"
};

const stoptime3 = {
  agency_id: "80801005354",
  route_short_name: "N26N11",
  service_id: "平日",
  departure_time: "07:00",
  stop_headsign: "東田子浦駅（大諏訪・片浜駅・原駅・桃里 経由）",
  stop_headsign_en: "Ashitaka-Undo-Koen[Numazu Sta. North-Entrance・Surugadai]",
  platform_code: "1"
};

const stoptime4 = {
  agency_id: "80801005354",
  route_short_name: "N26N11",
  service_id: "平日",
  departure_time: "07:30",
  stop_headsign: "あしたか運動公園 [沼津駅北口・リコー通り・江原公園・駿河台]",
  stop_headsign_en: "Ashitaka-Undo-Koen[Numazu Sta. North-Entrance・Surugadai]",
  platform_code: "1"
};
